import React, { useMemo } from 'react';
import {
  Content,
  LogoutButton,
  Sidebar,
  SidebarTitle,
  StyledModal,
  WizardGlobalStyle,
} from './Wizard.styles';
import { HudIcon } from '../Icons/HudIcons';
import Stepper, { StepperStep } from '../Stepper/Stepper';
import { isMobile } from '../utils';

type WizardStep = {
  step: StepperStep;
  content: React.ReactNode;
};

export interface WizardProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;

  currentStep: number;
  wizardSteps: WizardStep[];

  opened?: boolean;

  options?: {
    showLogo?: boolean;
    withCloseButton?: boolean;
    withClickOutsideToClose?: boolean;
  };
  onLogout: () => void;
}

export function Wizard({
  title,
  wizardSteps,
  currentStep,
  opened,
  options,
  onLogout,
}: WizardProps) {
  const stepperSteps = useMemo(() => wizardSteps.map((step) => step.step), [wizardSteps]);

  // The defined mobile behavior
  const showSidebar = !isMobile() || currentStep == 1;
  const showContent = !isMobile() || currentStep == 0;

  return (
    <StyledModal
      opened={opened}
      withCloseButton={options?.withCloseButton}
      withClickOutsideToClose={options?.withClickOutsideToClose}
      className={`wizard-modal step-${currentStep}`}
    >
      <WizardGlobalStyle />
      {showSidebar && (
        <Sidebar>
          <SidebarTitle>
            {options?.showLogo && <HudIcon icon="menu.hud" width="55px" height="22px" />}
            {title}
          </SidebarTitle>
          <Stepper steps={stepperSteps} currentStep={currentStep} />
          <LogoutButton onClick={onLogout} className="logout-button">
            <HudIcon icon="menu.logout" width="20px" height="20px" />
            Logout
          </LogoutButton>
        </Sidebar>
      )}
      {showContent && <Content>{wizardSteps[currentStep].content}</Content>}
    </StyledModal>
  );
}
